import React, { useCallback } from "react";
import { HStack, Text, Switch } from "@chakra-ui/react";

import { WalletIcon } from "components/Logos";

const WalletBalanceToggle = ({ wallet, isChecked, setChecked, isDisabled = false }) => {
  const walletBalance = wallet.spendable.balance;

  const handleOnChange = useCallback(() => {
    setChecked(!isChecked);
  }, [isChecked, setChecked]);

  const labelText = `Use your ${wallet.spendable.display} balance`;

  return (
    <HStack
      justifyContent="space-between"
      mt={4}
      px={4}
      py={3}
      bg="lightBackground"
      borderRadius={8}
    >
      <HStack spacing={2}>
        <WalletIcon />
        <Text fontSize="sm" fontWeight="medium">
          {labelText}
        </Text>
      </HStack>

      <Switch
        size="md"
        isChecked={isChecked}
        onChange={handleOnChange}
        isDisabled={isDisabled || walletBalance <= 0}
        aria-label={labelText}
        data-testid="wallet-toggle"
      />
    </HStack>
  );
};

export default WalletBalanceToggle;
